

<template>
 

  <div class="container put-right" style="direction:rtl">

      <h3 class="heading" style="display:initial;margin-left:2rem">المحاضر</h3>
        <form style="display:initial;">
 <router-link to="/AddRecord"> <button type="button" class="btn btn-primary">اضافة</button> </router-link>
      </form>


<div class="container menu">
<div class="table-responsive">
<table class="table">
  <thead>
    <tr>
      <th scope="col"> الترتيب</th>
      <th scope="col"> المحقق </th>
      <th scope="col"> المتهم  </th>
     
    </tr>
  </thead>
  <tbody>
    
    <tr v-for="keey in formdata2" :key="keey.id" >
      
      <th scope="row" >{{keey.id}}</th>
      <td>       {{keey.Inquisitor_name}} </td>
      <td>{{keey.accused_and_victim_name}}</td>
      <div class="right">
      <router-link :to="{ name: 'AddQuiz', params: { id: keey.id}}"> <button   class="icon-button orange text-white" > 
        اضافة اسئلة
     </button> </router-link>
      <router-link :to="{ name: 'QuizView', params: { id: keey.id}}"> <button   class="icon-button orange text-white" >
        التحقيق 
     </button> </router-link>
    </div>
    </tr>
   
  </tbody>
</table>
</div>
  
</div>
</div>


           


   

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name:"RecordView",
data(){
  return{
     formdata2:[],    
  }
},
mounted() {
  
 
    
       fetch(geturl()+"records/record/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data           
      })
    }
}
</script>

<style>

</style>
